import React, {useContext, useEffect} from "react";
import "./index.scss";
import {FormRow} from "../../../components/Form/FormRow";
import {addYears} from "../../../utils/dateUtils";
import {TravelQuotationCardContext} from "../../../contexts/TravelQuotationCardContext";
import {ParametrizedFieldOld} from "../../../components/ParametrizedFieldOld";
import moment from "moment";
import {strings} from "../../../strings/strings";

export interface IAdditionalPerson {
    personNumber: number
    formatResponse: (response: any) => any
}

export const AdditionalPerson: React.FC<IAdditionalPerson> = ({personNumber, formatResponse}) => {
    const {loadingAdditionalFromServer} = useContext(TravelQuotationCardContext);
    useEffect(() => {
        if(personNumber === 0){
            loadingAdditionalFromServer();
        }
    }, []);

    return (
        <form className={"additional-person"}>

            <h3 className={'mb-50'}>{`${strings.touristData} ${personNumber + 1}`}</h3>

            <FormRow className={'additional-person_row'} columns={2}>
                <ParametrizedFieldOld contextName={`mainPerson-travelPerson-surname`}
                                   quotationName={`quotation.travelWebContract.`}
                                   contextPath={`mainContract.get().riskObjects.get(${personNumber})`}
                                   context={TravelQuotationCardContext}
                                   defaultLabel={strings.travelSurnameLabel}
                                   convertContextNameFunction={(name) => {
                                       return `persons[${personNumber}].surname`
                                   }}
                                   formatResponse={formatResponse}/>
                <ParametrizedFieldOld contextName={`mainPerson-travelPerson-givenName`}
                                   quotationName={`quotation.travelWebContract.`}
                                   contextPath={`mainContract.get().riskObjects.get(${personNumber})`}
                                   context={TravelQuotationCardContext}
                                   defaultLabel={strings.travelNameLabel}
                                   convertContextNameFunction={(name) => {
                                       return `persons[${personNumber}].givenName`
                                   }}
                                   formatResponse={formatResponse}/>
            </FormRow>

            <FormRow className={'additional-person_row'} columns={2}>
                <ParametrizedFieldOld contextName={'mainPerson-travelPerson-birthDate'}
                                   quotationName={'quotation.travelWebContract.'}
                                   defaultFieldNotRequired={true}
                                   context={TravelQuotationCardContext}
                                   convertContextNameFunction={(name) => {
                                       return `persons[${personNumber}].birthDate`
                                   }}
                                   contextPath={`mainContract.get().riskObjects.get(${personNumber})`}
                                   minDate={addYears(new Date(), -100)}
                                   maxDate={new Date()}
                                   formatResponse={(option: string) => {
                                       const date = moment(option, 'DD.MM.YYYY').toDate();
                                       return {
                                           quotationValue: moment(date).format('YYYY-MM-DD'),
                                           value: moment(date).format('DD.MM.YYYY')
                                       }
                                   }
                                   }/>

                <ParametrizedFieldOld contextName={`mainPerson-travelPerson-registrationDocument-number`}
                                   defaultLabel={strings.internationalPassport}
                                   quotationName={'quotation.travelWebContract.'}
                                   contextPath={`mainContract.get().riskObjects.get(${personNumber})`}
                                   context={TravelQuotationCardContext}
                                   convertContextNameFunction={(name) => {
                                       return `persons[${personNumber}].documentNumber`
                                   }}
                                   formatResponse={formatResponse}/>
            </FormRow>


            <FormRow className={'additional-person_row'} columns={1}>
                <ParametrizedFieldOld contextName={'mainPerson-travelPerson-registrationAddress-unstructured'}
                                   quotationName={'quotation.travelWebContract.'}
                                   defaultLabel={strings.travelAddressLabel}
                                   contextPath={`mainContract.get().riskObjects.get(${personNumber})`}
                                   context={TravelQuotationCardContext}
                                   convertContextNameFunction={(name) => {
                                       return `persons[${personNumber}].address`
                                   }}
                                   formatResponse={formatResponse}/>
            </FormRow>


            <FormRow className={'additional-person_row'} columns={2}>
                <ParametrizedFieldOld contextName={'mainPerson-travelPerson-mobileNumber'}
                                   defaultLabel={strings.insuredPhone}
                                   quotationName={'quotation.travelWebContract.'}
                                   context={TravelQuotationCardContext}
                                   mask={'+38(999)9999999'}
                                   contextPath={`mainContract.get().riskObjects.get(${personNumber})`}
                                   convertContextNameFunction={(name) => {
                                       return `persons[${personNumber}].mobileNumber`
                                   }}
                                   formatResponse={formatResponse}/>
            </FormRow>

        </form>
    )
};
